<template>
	<div>
		<div class="row mb-3">
			<div class="col-xs-12 col-sm-3 text-center mb-1">
				<select id="resourcedate" v-model="resourceDate" class="form-select" @change="search">
					<option value=""> Search by year </option>
					<option v-for="date in uniqueDates" :key="date.id"> {{date}} </option>
				</select>
			</div>
			<div class="col-xs-12 col-sm-3 text-center mb-1">
				<select id="resourcecategory" v-model="resourceCategory" class="form-select" @change="search">
					<option value=""> Search by category </option>
					<option v-for="category in uniqueCategories" :key="category.id"> {{category}} </option>
				</select>
			</div>
			<div class="col-xs-12 col-sm-3 text-center mb-1">
				<select id="sourcecategory" v-model="resourceSource" class="form-select" @change="search">
					<option value=""> Search by source </option>
					<option v-for="source in uniqueSources" :key="source.id"> {{source}} </option>
				</select>
			</div>
			<div class="col-xs-12 col-sm-3 mb-1">
				<button type="button" class="btn btn-success" id="refresh" @click="refresh">Refresh</button>
			</div>
		</div>
		<div class="row">
			<div id="resources" class="col-4 mt-3" v-for="resource in sortedResources" :key="resource.id">
				<h5> <a class="greeni" :href="resource.link" target="__blank"> {{resource.item}} </a> </h5> 
				<div class="small pr-3"> <p> {{resource.category}} | {{resource.date}} | {{resource.source}} </p> </div>
				<p> {{resource.details}} </p>
			</div>
		</div>
	</div>
</template>

<script>
import getResources from '../services/Spreadsheets'
export default {
	name: 'ResourceList',
	props: {},
	data() {
		return {
			resources: [],
			sortedResources: [],
			loaded: false,
			activeButton: "",
			resourceYears: [],
			resourceDate: "",
			uniqueDates: [],
			resourceCategory: "",
			uniqueCategories: [],
			resourceSource: "",
			uniqueSources: [],
		}
	},
	methods: {
		search() {

			this.sortedResources = []

			for (let i = this.resources.length - 1; i>=0; i--) {

				let year = this.resources[i].date
				let category = this.resources[i].category
				let source = this.resources[i].source
				let yearmatch = false;	
				let categorymatch = false;
				let sourcematch = false;

				if (this.resourceDate) {
					if (this.resourceDate == year) {
						yearmatch = true
					}
				} else {
					yearmatch = true
				}
				
				if (this.resourceCategory) {
					if (this.resourceCategory == category) {
						categorymatch = true
					}
				} else {
					categorymatch = true
				}

				if (this.resourceSource) {
					if (this.resourceSource == source) {
						sourcematch = true
					}
				} else {
					sourcematch = true
				}


				if ((yearmatch) && (categorymatch) && (sourcematch)) {
					this.sortedResources.push(this.resources[i])
				}
				this.sortedResources.reverse();
			}
		},

		refresh() {
			this.sortedResources = this.resources
			this.resourceDate = ""
			this.resourceCategory = ""
			this.resourceSource = ""
		}
	},
	async mounted() {
		const resp = await getResources.getResources();
		this.resources = resp.data
		this.sortedResources = resp.data
		this.loaded = true
		
		let dates = []
		let categories = []
		let sources = []
		for (let i = this.resources.length -1; i>=0; i--) {
			dates.push(this.resources[i].date)
			categories.push(this.resources[i].category)
			sources.push(this.resources[i].source)
		}
		this.uniqueDates = [... new Set(dates)].sort()
		this.uniqueCategories = [... new Set(categories)].sort()
		this.uniqueSources = [... new Set(sources)].sort()
	}
}
</script>

<style>

</style>